<div [formGroup]="formGroup" class="form-group kt-form__group row">
    <div class="col-lg-12 kt-margin-bottom-20-mobile" *ngIf="title.length > 0">
        <h5 class="my-3 text-mad text-uppercase">
            {{title}}
        </h5>
        <hr class="active">
    </div>

    <div class="col-12">
        <div class="row">
            <div class="col-8">
                <div class="row">
                    <div class="col-12" *ngIf="showMap">
                        <div class="search-by-location">
                            <mat-form-field class="mat-form-field-fluid">
                                <input matInput type="text" (keydown.enter)="$event.preventDefault()"
                                    [placeholder]="'GENERAL.PLACEHOLDER.SEARCH_BY_CITY' | translate" autocorrect="off"
                                    autocapitalize="off" spellcheck="off" #search />
                                <mat-icon matSuffix class="cursor-pointer" (click)="$event.stopPropagation();"
                                    container="body" [ngbPopover]="'TOOLTIP.HOUSE.LOCATE.DESCRIPTION' | translate"
                                    [popoverTitle]="'TOOLTIP.HOUSE.LOCATE.TITLE' | translate">help
                                </mat-icon>
                            </mat-form-field>
                            <mat-checkbox [formControl]="useAsAddressControl">
                                Use as property address
                            </mat-checkbox>
                        </div>
                    </div>
                    <div class="col-lg-12 kt-margin-bottom-20-mobile mb-4" *ngIf="showMap">
                        <agm-map [latitude]="centerLatitude$|async" [longitude]="centerLongitude$|async" [zoom]="zoom"
                            (mapReady)="onMapReady($event)" (centerChange)="centerChange($event)" [scrollwheel]="false"
                            [usePanning]="true" [clickableIcons]="false">
                            <agm-map-type-control></agm-map-type-control>
                            <button type="button" id="Profile" class="btn btn-light btn-icon mr-2 map-button"
                                (click)="setLocation()">
                                <mat-icon>my_location</mat-icon>
                            </button>
                            <agm-map-type-control></agm-map-type-control>
                            <agm-marker *ngIf="isShown" [latitude]="markerLat" [longitude]="markerLng"
                                [markerDraggable]="!lockMarker" (dragEnd)="markerDragEnd($event)">
                            </agm-marker>
                        </agm-map>
                        <mat-error [matErrorState]="formGroup.controls['latitude']">
                            Location <strong>required</strong> (right-click to define location)
                        </mat-error>
                    </div>
                </div>
            </div>

            <div class="col-4">
                <div class="d-flex flex-column justify-content-between h-100">
                    <div class="row">
                        <div class="col-lg-6 kt-margin-bottom-20-mobile">
                            <mat-form-field class="mat-form-field-fluid">
                                <mat-select [placeholder]="'Country'" formControlName="country_id"
                                    (selectionChange)="selectCountry()">
                                    <mat-option *ngFor="let country of allCountries"
                                        [value]="country.id">{{country.name}}</mat-option>
                                </mat-select>
                                <mat-error>
                                    Country <strong>required</strong>
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg-6 kt-margin-bottom-20-mobile">
                            <mat-form-field class="mat-form-field-fluid">
                                <mat-select [placeholder]="'City'" formControlName="city_id">
                                    <mat-option [value]="0">Not Applicable</mat-option>
                                    <mat-option *ngFor="let city of cityOfCountry"
                                        [value]="city.id">{{city.name}}</mat-option>
                                </mat-select>
                                <mat-error>
                                    City <strong>required</strong>
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg-6">
                            <mat-form-field class="mat-form-field-fluid">
                                <mat-select placeholder="Commmunity" formControlName="community">
                                    <mat-option>
                                        <ngx-mat-select-search [formControl]="communitySearchControl"
                                            [placeholderLabel]="'GENERAL.PLACEHOLDER.SEARCH'|translate"
                                            [noEntriesFoundLabel]="'GENERAL.MESSAGE.NOT_FOUND'|translate:{
                                                entry: 'Community'
                                            }">
                                        </ngx-mat-select-search>
                                    </mat-option>
                                    <mat-option *ngFor="let option of communities$|async" [value]="option.id">
                                        {{ option.name }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-lg-6 kt-margin-bottom-10-mobile">
                            <mat-form-field class="mat-form-field-fluid">
                                <input matInput [placeholder]="'Zipcode/Postalcode'" formControlName="zip_code" />
                            </mat-form-field>
                        </div>
                        <div class="col-lg-6 kt-margin-bottom-10-mobile">
                            <mat-form-field class="mat-form-field-fluid"
                                [formFieldState]="formGroup.controls['location_grade_id']">
                                <mat-select [placeholder]="'Location Grade'" formControlName="location_grade_id">
                                    <mat-option *ngFor="let grade of grades"
                                        [value]="grade.id">{{grade.name}}</mat-option>
                                </mat-select>
                                <mat-hint [formFieldHintState]="formGroup.controls['location_grade_id']">
                                    Location Grade is <span>required</span>
                                </mat-hint>
                                <mat-error>
                                    Location Grade is <strong>required</strong>
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg-12 kt-margin-b-10-mobile">
                            <mat-form-field class="mat-form-field-fluid"
                                [formFieldState]="formGroup.controls['address']">
                                <textarea matInput rows="4" [placeholder]="'Address'"
                                    formControlName="address"></textarea>
                                <mat-hint [formFieldHintState]="formGroup.controls['address']">
                                    Address is <span>required</span>
                                </mat-hint>
                                <mat-error>
                                    Address is <strong>required</strong>
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12 kt-margin-b-10-mobile" *ngIf="isComplexForm">
                            <mat-form-field class="mat-form-field-fluid"
                                [formFieldState]="formGroup.controls['location_surrounding']">
                                <textarea matInput rows="4" [placeholder]="'Location and Surroundings Description'"
                                    formControlName="location_surrounding"></textarea>
                                <mat-error>
                                    Description <strong>required</strong>
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>